export const ROUTE = {
  dashboard: '/dashboard',
  login: '/login',
  signup: '/signup'
}
